import Network from '../lib/network';
import { receiveEntity } from './entities';

const api = Network();

const path = resource => {
  if (!resource) resource = '';
  return { resource: 'api/prequalification/' + resource };
}

export const createPrequalification = data => {
  return (dispatch, getState) => {
    const merchant = getState().entities.get('merchant').last();

    return api.post(path(), { ...data, public_key: merchant.public_key })
      .then(res => dispatch(receiveEntity({
          data: {
            id: 1,
            type: 'prequalification',
            attributes: { ...data, ...res }
          }
        })));
  }
}

export const getPrequalification = id => {
  return (dispatch, getState) => {
    return api.get(path(id))
      .then(res => dispatch(receiveEntity(res)));
  }
}
